import React, { useRef, useEffect, useState, useContext } from "react";
import * as tf from "@tensorflow/tfjs";
import * as poseDetection from "@tensorflow-models/pose-detection";
import Webcam from "react-webcam";
import { UserContext, backendUrl } from "../App";
import {
  drawPoint,
  drawSegment,
  keypointConnections,
  POINTS,
  find_angle,
  speak,
} from "../utilities";
import { useLocation } from "react-router-dom";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";

// Hook
function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match

  // not using now, will fix later
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return windowSize;
}

function Exercisetracker(props) {
  let skeletonColor = "rgb(255,255,255)";

  const webcamRef = useRef(null);
  const canvasRef = useRef(null);
  const [prompt, setPrompt] = useState("This is defualt text");
  const [counter, setCounter] = useState(0);
  const [playStatus, setPlayStatus] = useState("_play");
  const [scores, setScores] = useState(0);
  const [isDown, setIsDown] = useState(false);
  const {
    goalrepeticion,
    setGoalrepeticion,
    currentRepetition,
    setCurrentRepetition,
    user,
    setUser,
  } = useContext(UserContext);
  // const {{}

  function instructions(text) {
    speechSynthesis.cancel();
    setPlayStatus((prev) => {
      if (prev === "_play") {
        // if uncommenting code above, replace textToRead with text here
        speak(text, setPlayStatus, window.speechSynthesis);
        return "_pause";
      }
      return "_play";
    });
  }

  const { state } = useLocation();
  async function runMovenet() {
    console.log(state);
    const detectorConfig = {
      modelType: poseDetection.movenet.modelType.SINGLEPOSE_THUNDER,
    };
    const detector = await poseDetection.createDetector(
      poseDetection.SupportedModels.MoveNet,
      detectorConfig
    );
    setInterval(() => {
      detectPose(detector);
    }, 100);
  }

  async function detectPose(detector) {
    try {
      if (
        typeof webcamRef.current !== "undefined" &&
        webcamRef.current !== null &&
        webcamRef.current.video.readyState === 4
      ) {
        const video = webcamRef.current.video;
        const pose = await detector.estimatePoses(video);
        const ctx = canvasRef.current.getContext("2d");
        ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
        const keypoints = pose[0].keypoints;

        let input = keypoints.map((keypoint) => {
          if (keypoint.score > 0.4) {
            if (
              !(keypoint.name === "left_eye" || keypoint.name === "right_eye")
            ) {
              drawPoint(ctx, keypoint.y, keypoint.x, 8, "rgb(255,255,255)");
              let connections = keypointConnections[keypoint.name];
              try {
                connections.forEach((connection) => {
                  let conName = connection.toUpperCase();
                  drawSegment(
                    [keypoint.y, keypoint.x],
                    [
                      keypoints[POINTS[conName]].y,
                      keypoints[POINTS[conName]].x,
                    ],
                    skeletonColor,
                    1,
                    ctx
                  );
                });
              } catch (err) {}
            }
          }
          return [-keypoint.x, keypoint.y];
        });
        // if (state.exercise == 'bicep') {
        bicepCurl(keypoints);
        // barbelFrontLateralRaise(keypoints);
        // }
        // if (state.exercise == 'lunge') {
        // lunge(keypoints);
        // }
      }
    } catch (err) {
      console.log(err);
    }
  }

  function barbelFrontLateralRaise(keypoints) {
    let angleRight =
      (find_angle(
        {
          x: keypoints[POINTS["RIGHT_SHOULDER"]].x,
          y: keypoints[POINTS["RIGHT_SHOULDER"]].y,
        },
        {
          x: keypoints[POINTS["RIGHT_ELBOW"]].x,
          y: keypoints[POINTS["RIGHT_ELBOW"]].y,
        },
        {
          x: keypoints[POINTS["RIGHT_WRIST"]].x,
          y: keypoints[POINTS["RIGHT_WRIST"]].y,
        }
      ) *
        180) /
      Math.PI;

    let angleLeft =
      (find_angle(
        {
          x: keypoints[POINTS["LEFT_SHOULDER"]].x,
          y: keypoints[POINTS["LEFT_SHOULDER"]].y,
        },
        {
          x: keypoints[POINTS["LEFT_ELBOW"]].x,
          y: keypoints[POINTS["LEFT_ELBOW"]].y,
        },
        {
          x: keypoints[POINTS["LEFT_WRIST"]].x,
          y: keypoints[POINTS["LEFT_WRIST"]].y,
        }
      ) *
        180) /
      Math.PI;

    let leftSide =
      (find_angle(
        {
          x: keypoints[POINTS["LEFT_ELBOW"]].x,
          y: keypoints[POINTS["LEFT_ELBOW"]].y,
        },
        {
          x: keypoints[POINTS["LEFT_SHOULDER"]].x,
          y: keypoints[POINTS["LEFT_SHOULDER"]].y,
        },
        {
          x: keypoints[POINTS["LEFT_HIP"]].x,
          y: keypoints[POINTS["LEFT_HIP"]].y,
        }
      ) *
        180) /
      Math.PI;

    let rightSide =
      (find_angle(
        {
          x: keypoints[POINTS["RIGHT_ELBOW"]].x,
          y: keypoints[POINTS["RIGHT_ELBOW"]].y,
        },
        {
          x: keypoints[POINTS["RIGHT_SHOULDER"]].x,
          y: keypoints[POINTS["RIGHT_SHOULDER"]].y,
        },
        {
          x: keypoints[POINTS["RIGHT_HIP"]].x,
          y: keypoints[POINTS["RIGHT_HIP"]].y,
        }
      ) *
        180) /
      Math.PI;
    // console.log(leftSide, rightSide, "left and right anglesss")
    // if (leftSide > 90 && rightSide > 90) {
    //   setPrompt("Keep your back straight");
    //   skeletonColor = "rgb(255,0,0)";
    //   return;
    // } else if (
    //   angleRight < 20 &&
    //   angleLeft < 20 &&
    //   skeletonColor != "rgb(255,255,255)"
    // ) {
    //   setPrompt("Good job!");
    //   skeletonColor = "rgb(0,255,0)";
    //   return;
    // }
    // else
    // if(
    //   angleRight > 165 && angleLeft > 165
    // )
  }

  function bicepCurl(keypoints) {
    let angleRight =
      (find_angle(
        {
          x: keypoints[POINTS["RIGHT_SHOULDER"]].x,
          y: keypoints[POINTS["RIGHT_SHOULDER"]].y,
        },
        {
          x: keypoints[POINTS["RIGHT_ELBOW"]].x,
          y: keypoints[POINTS["RIGHT_ELBOW"]].y,
        },
        {
          x: keypoints[POINTS["RIGHT_WRIST"]].x,
          y: keypoints[POINTS["RIGHT_WRIST"]].y,
        }
      ) *
        180) /
      Math.PI;

    let angleLeft =
      (find_angle(
        {
          x: keypoints[POINTS["LEFT_SHOULDER"]].x,
          y: keypoints[POINTS["LEFT_SHOULDER"]].y,
        },
        {
          x: keypoints[POINTS["LEFT_ELBOW"]].x,
          y: keypoints[POINTS["LEFT_ELBOW"]].y,
        },
        {
          x: keypoints[POINTS["LEFT_WRIST"]].x,
          y: keypoints[POINTS["LEFT_WRIST"]].y,
        }
      ) *
        180) /
      Math.PI;

    let leftSide =
      (find_angle(
        {
          x: keypoints[POINTS["LEFT_ELBOW"]].x,
          y: keypoints[POINTS["LEFT_ELBOW"]].y,
        },
        {
          x: keypoints[POINTS["LEFT_SHOULDER"]].x,
          y: keypoints[POINTS["LEFT_SHOULDER"]].y,
        },
        {
          x: keypoints[POINTS["LEFT_HIP"]].x,
          y: keypoints[POINTS["LEFT_HIP"]].y,
        }
      ) *
        180) /
      Math.PI;

    let rightSide =
      (find_angle(
        {
          x: keypoints[POINTS["RIGHT_ELBOW"]].x,
          y: keypoints[POINTS["RIGHT_ELBOW"]].y,
        },
        {
          x: keypoints[POINTS["RIGHT_SHOULDER"]].x,
          y: keypoints[POINTS["RIGHT_SHOULDER"]].y,
        },
        {
          x: keypoints[POINTS["RIGHT_HIP"]].x,
          y: keypoints[POINTS["RIGHT_HIP"]].y,
        }
      ) *
        180) /
      Math.PI;
    // console.log(leftSide, rightSide, "left and right anglesss")

    console.log(angleRight, angleLeft, "angleessss");
    if (angleRight > 165 && angleLeft > 165) {
      // setPrompt("down");
      // if(isDown) {
      //   setScores((scores) => scores + 0.5);
      // }
      // setIsDown(true);
      // setScores((scores) => scores + 0.5);
      skeletonColor = "rgb(0,255,0)";
      return;
    } else if (
      angleRight < 20 &&
      angleLeft < 20 &&
      skeletonColor != "rgb(255,255,255)"
    ) {
      setPrompt("up");
      skeletonColor = "rgb(255,255,255)";
      // setScores((scores) => scores + 1);
      setCurrentRepetition((currentRepetition) => currentRepetition + 1);
      return;
    }
  }
  useEffect(() => {
    async function initializeTF() {
      await tf.ready();
      runMovenet();
    }

    initializeTF();
  }, []);

  const increaseStreak = async () => {
    const token = localStorage.getItem("self_care_token");
    await axios
      .put(
        `${backendUrl}/api/user/updateuser/${user._id}`,
        {
          streak: user.streak + 1,
        },
        {
          headers: {
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setUser(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (currentRepetition == goalrepeticion) {
      // alert("You've reached your goal!");
      if (goalrepeticion > 0) {
        toast.success("You've reached your goal!");
        localStorage.setItem("current_time_completed", Date.now());
      }
      increaseStreak();
    }
  }, [currentRepetition]);

  // useEffect(() => {
  //   alert(prompt);
  // }, [prompt])

  async function lunge(keypoints) {
    if (
      keypoints[POINTS["RIGHT_HIP"]].score < 0.45 ||
      keypoints[POINTS["LEFT_HIP"]].score < 0.45
    ) {
      setPrompt("Adjust your camera");
      skeletonColor = "rgb(255,255,255)";
      return;
    }
    let angleRight =
      (find_angle(
        {
          x: keypoints[POINTS["RIGHT_HIP"]].x,
          y: keypoints[POINTS["RIGHT_HIP"]].y,
        },
        {
          x: keypoints[POINTS["RIGHT_KNEE"]].x,
          y: keypoints[POINTS["RIGHT_KNEE"]].y,
        },
        {
          x: keypoints[POINTS["RIGHT_ANKLE"]].x,
          y: keypoints[POINTS["RIGHT_ANKLE"]].y,
        }
      ) *
        180) /
      Math.PI;

    let angleLeft =
      (find_angle(
        {
          x: keypoints[POINTS["LEFT_HIP"]].x,
          y: keypoints[POINTS["LEFT_HIP"]].y,
        },
        {
          x: keypoints[POINTS["LEFT_KNEE"]].x,
          y: keypoints[POINTS["LEFT_KNEE"]].y,
        },
        {
          x: keypoints[POINTS["LEFT_ANKLE"]].x,
          y: keypoints[POINTS["LEFT_ANKLE"]].y,
        }
      ) *
        180) /
      Math.PI;
    // console.log(angleRight, angleLeft, "right and left angles")
    // setPrompt("Please correct your form")
    if (angleRight > 100 && angleLeft > 100) {
      alert("Please correct your form");
      skeletonColor = "rgb(255,0,0)";
    } else {
      // instructions("Good job!");
      setPrompt("Correct. Hold for 15 seconds");
      skeletonColor = "rgb(0,255,0)";
      instructions("Try to correct your posture");
    }

    if (skeletonColor == "rgb(255,255,255)") {
      console.log("2", skeletonColor);
    }
    if (skeletonColor === "rgb(0,255,0)") {
      console.log("1", skeletonColor);
    }
    if (skeletonColor === "rgb(255,0,0)") {
      console.log("3", skeletonColor);
    }
  }

  useEffect(() => {
    runMovenet();
  }, []);

  // const size = useWindowSize();
  // const isLandscape = size.height <= size.width;
  // const ratio = isLandscape
  //   ? size.width / size.height
  //   : size.height / size.width;

  return (
    <div className="App">
      <ToastContainer />
      <header className="">
        <Webcam
          videoConstraints={{ facingMode: "user" }}
          id="webcam"
          ref={webcamRef}
          width="640px"
          height="480px"
          style={{
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            borderRadius: "5px",
          }}
        />
        <canvas
          ref={canvasRef}
          id="my-canvas"
          width="640px"
          height="480px"
          style={{
            position: "absolute",
            left: "50%",
            top: "50%",
            zIndex: 1,
            transform: "translate(-50%, -50%)",
          }}
        />
      </header>
      <h1 className="text-2xl font-bold">
        {prompt} and score: {currentRepetition}
      </h1>
    </div>
  );
}

export default Exercisetracker;
